import { render, staticRenderFns } from "./DuesRow.vue?vue&type=template&id=3a654148"
import script from "./DuesRow.vue?vue&type=script&lang=js"
export * from "./DuesRow.vue?vue&type=script&lang=js"
import style0 from "./DuesRow.vue?vue&type=style&index=0&id=3a654148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports